import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=fa5d334a&scoped=true"
import script from "./jobs.vue?vue&type=script&lang=js"
export * from "./jobs.vue?vue&type=script&lang=js"
import style0 from "./jobs.vue?vue&type=style&index=0&id=fa5d334a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5d334a",
  null
  
)

export default component.exports